import apiService from '../../../core/services/API';
import {environment} from '../../../environments/environment';

export function sendEmails(data) {
    return apiService.post({
        url: `${environment.api.sendEmails}`,
        data
    });
}
